// extracted by mini-css-extract-plugin
export default {"password-hint":"ForgotSet_password-hint__ZZj3g"};